import {
    APIProvider,
    AdvancedMarker,
    Map,
    useAdvancedMarkerRef,
} from '@vis.gl/react-google-maps';
import React, { useState } from 'react';
import { MapHandler } from './mapHandler';
import { PlaceAutocomplete } from './placeAutocomplete';

interface MapComponentProps {
    defaultCenter: { lat: number; lng: number };
    defaultZoom: number;
    selectedPoint: { lat: number; lng: number } | null;
    onMapClick: (lat: number, lng: number) => void;
    onPlaceSelect: (place: google.maps.places.PlaceResult | null) => void;
    setDisableName: React.Dispatch<React.SetStateAction<boolean>>
    setValue: React.Dispatch<React.SetStateAction<string>>
    value: string
}

const MapActivity = React.memo(({
    defaultCenter,
    defaultZoom,
    selectedPoint,
    onMapClick,
    onPlaceSelect,
    setDisableName,
    setValue,
    value
}: MapComponentProps) => {

    const [markerRef, marker] = useAdvancedMarkerRef();
    const [selectedPlace, setSelectedPlace] =
        useState<google.maps.places.PlaceResult | null>(null);


    const handlePlaceSelect = (place: google.maps.places.PlaceResult | null) => {
        setSelectedPlace(place);
        onPlaceSelect(place); // Notificar al componente padre
        if (place?.geometry?.location) {
            onMapClick(place.geometry.location.lat(), place.geometry.location.lng()); // Actualizar el punto seleccionado
        }
    };

    const API_KEY = process.env.REACT_APP_MAP_APIKEY ?? ''

    return (
        <APIProvider apiKey={API_KEY}>
            <PlaceAutocomplete onPlaceSelect={handlePlaceSelect} value={value} setDisableName={setDisableName} setValue={setValue} />
            <Map
                mapId={'jasdk12q3'}
                defaultZoom={defaultZoom}
                defaultCenter={defaultCenter}
                mapTypeId={'roadmap'}
                gestureHandling={'greedy'}
                disableDefaultUI={true}
                zoomControl={true}
                fullscreenControl={true}
                onClick={(e) => {
                    const lat = e.detail.latLng?.lat;
                    const lng = e.detail.latLng?.lng;
                    if (lat && lng) {
                        const geocoder = new google.maps.Geocoder()

                        geocoder.geocode({ location: { lat, lng } }, (results, status) => {
                            if (status === 'OK' && results?.[0]) {
                                setValue(results[0].formatted_address ?? '')
                            } else {
                                console.error('Geocode was not successful for the following reason:', status)
                            }
                        })
                        onMapClick(lat, lng);
                    }
                }}
            >
                {selectedPoint && (
                    <AdvancedMarker
                        ref={markerRef}
                        position={{ lat: selectedPoint.lat, lng: selectedPoint.lng }}
                    />
                )}
                
                <MapHandler place={selectedPlace} marker={marker} />
            </Map>
        </APIProvider>
    )
})

export { MapActivity }